import { SoundSlider } from "@kalyzee/kalyzee-ui";
import { useEffect, useState } from "react";
import { useAppContext } from "../../contexts/app/context";

export const AppSoundSlider = () => {
  const nativeAppCtx = useAppContext();

  const [premuteValue, setPremuteValue] = useState(0);

  useEffect(() => {
    if (nativeAppCtx?.volume) {
      setPremuteValue(0);
    }
  }, [nativeAppCtx?.volume]);

  if (!nativeAppCtx || nativeAppCtx.volume === -1) return null;

  return (
    <SoundSlider
      min={0}
      max={100}
      value={nativeAppCtx.volume}
      step={1}
      style={{ fontSize: "0.75em" }}
      onChange={nativeAppCtx.setVolume}
      onMute={() => {
        if (nativeAppCtx.volume) {
          setPremuteValue(nativeAppCtx.volume);
          nativeAppCtx.setVolume(0);
        } else {
          nativeAppCtx.setVolume(premuteValue || 50);
        }
      }}
    />
  )
}